<form
  class="profile-form d-flex flex-column mx-4 flex-wrap location-form position-relative"
  [formGroup]="profileForm"
  >
  <!--  <mat-slide-toggle-->
  <!--    class="my-2"-->
  <!--    *ngIf="showPrivateToggle"-->
  <!--    formControlName="visibility_id"-->
  <!--  >-->
  <!--    Private-->
<!--  </mat-slide-toggle>-->
<mat-form-field class="mt-2 form-column">
  <mat-label>Username</mat-label>
  <input
    matInput
    [maxlength]="maxInputLength"
    placeholder="Username"
    formControlName="username"
    required
    />
    @if (profileForm.get('username').hasError('required')) {
      <mat-error>
        {{ERROR_MSG.required}}
      </mat-error>
    }
    @if (profileForm.get('username').hasError('minLength')) {
      <mat-error>
        This field must contain at least 2 characters
      </mat-error>
    }
    @if (profileForm.get('username').hasError('maxlength')) {
      <mat-error>
        This field must be less than 20 characters
      </mat-error>
    }
  </mat-form-field>
  <mat-form-field
    class=" form-column">
    <mat-label>Full Name</mat-label>
    <input
      matInput
      [maxlength]="maxInputLength"
      [placeholder]="profileForm.get('fullname').value || !isDisabled ? 'Full Name' : ''"
      formControlName="fullname"
      required
      />
      @if (profileForm.get('fullname').hasError('required')) {
        <mat-error
          >
          {{ERROR_MSG.required}}
        </mat-error>
      }
      @if (profileForm.get('fullname').hasError('minLength')) {
        <mat-error>
          This field must contain at least 2 characters
        </mat-error>
      }
      @if (profileForm.get('fullname').hasError('maxlength')) {
        <mat-error
          >
          This field must be less than 20 characters
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field class="form-column">
      <mat-label>Email</mat-label>
      <input
        matInput
        [maxlength]="emailMaxLength"
        required
        placeholder="Email"
        formControlName="email"
        />
        @if (profileForm.get('email').hasError('required')) {
          <mat-error>
            {{ERROR_MSG.required}}
          </mat-error>
        }
        @if (profileForm.get('email').hasError('pattern')) {
          <mat-error>
            Invalid email format
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field
        class="form-column"
        >
        <mat-label>Phone #</mat-label>
        <input
          matInput
          [mask]="phoneNumberMask"
          [maxlength]="maxInputLength"
          [placeholder]="profileForm.get('phone_number').value || !isDisabled ? 'Phone Number' : ''"
          formControlName="phone_number"
          />
          @if (profileForm.get('phone_number').invalid) {
            <mat-error>
              Invalid phone number format
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="bio-textarea">
          <mat-label>Bio</mat-label>
          <textarea matInput  formControlName="bio" [rows]="auto"></textarea>
          @if (profileForm.get('bio').hasError('maxlength')) {
            <mat-error>
              {{ERROR_MSG['max-length']}} {{BIO_MAX_LENGTH}}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Country</mat-label>
          <mat-select
            formControlName="country"
            (valueChange)="countryChanged($event)"
            >
            @for (country of countries; track country) {
              <mat-option [value]="country.iso2">
                {{ country.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>State</mat-label>
          <input
            type="text"
            [maxlength]="maxInputLength"
            matInput
            [placeholder]="profileForm.get('state').value || !profileForm.get('state').disabled ? 'State' : ''"
            formControlName="state"
            [matAutocomplete]="stateAuto"
            />
            <mat-autocomplete
              #stateAuto="matAutocomplete"
              (optionSelected)="stateSelected($event)"
              >
              @for (state of filteredStates | async; track state) {
                <mat-option
                  [value]="state"
                  >
                  {{ state.name }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field>
            <mat-label>City</mat-label>
            <input
              type="text"
              matInput
      [placeholder]="
          profileForm.get('city').value || !profileForm.get('city').disabled
            ? 'City'
            : ''
        "
              formControlName="city"
              [matAutocomplete]="auto"
              />
              <mat-autocomplete #auto="matAutocomplete">
                @for (city of filteredCities | async; track city) {
                  <mat-option
                    [value]="city.name"
                    >
                    {{ city.name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <app-week-days
              class="mb-2"
              [newActiveDay]="weekDays"
              (changeDay)="profileForm.get('available_days').setValue($event)"
              >
            </app-week-days>

            <ng-container formGroupName="social_medias">
              <mat-form-field
                class="mt-2"
                [class.cursor-pointer]="!!getFormValue('twitch')"
                (click)="redirectToSocialMedia(getFormValue('twitch'))"
                >
                <mat-label>Twitch profile link</mat-label>
                <input
                  matInput
                  [placeholder]=" getFormValue('twitch') || !mediaControls.get('twitch').disabled ? 'Twitch profile link': ''"
                  formControlName="twitch"
                  />
                  <div class="icon icon-twitch" matPrefix></div>
                  @if (mediaControls.get('twitch').hasError('pattern')) {
                    <mat-error>
                      Wrong link format
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field
                  class="0"
                  [class.cursor-pointer]="!!getFormValue('facebook')"
                  (click)="redirectToSocialMedia(getFormValue('facebook'))"
                  >
                  <mat-label>Facebook profile link</mat-label>
                  <input
                    matInput
        [placeholder]="
            getFormValue('facebook') || !mediaControls.get('facebook').disabled
              ? 'Facebook profile link'
              : ''
          "
                    formControlName="facebook"
                    />
                    <div class="icon icon-facebook" matPrefix></div>
                    @if (mediaControls.get('facebook').hasError('pattern')) {
                      <mat-error>
                        Wrong link format
                      </mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field
                    [class.cursor-pointer]="!!getFormValue('linkedin')"
                    (click)="redirectToSocialMedia(getFormValue('linkedin'))"
                    >
                    <mat-label>Linkedin profile link</mat-label>
                    <input
                      matInput
        [placeholder]="
            getFormValue('linkedin') || !mediaControls.get('linkedin').disabled
              ? 'Linkedin profile link'
              : ''
          "
                      formControlName="linkedin"
                      />
                      <div class="icon icon-linkedin" matPrefix></div>
                      @if (mediaControls.get('linkedin').hasError('pattern')) {
                        <mat-error>
                          Wrong link format
                        </mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field
                      [class.cursor-pointer]="!!getFormValue('vimeo')"
                      (click)="redirectToSocialMedia(getFormValue('vimeo'))"
                      >
                      <mat-label>Vimeo profile link</mat-label>
                      <input
                        matInput
        [placeholder]="
            mediaControls.get('vimeo').value ||
            !mediaControls.get('vimeo').disabled
              ? 'Vimeo profile link'
              : ''
          "
                        formControlName="vimeo"
                        />
                        <div class="icon icon-vimeo" matPrefix></div>
                        @if (mediaControls.get('vimeo').hasError('pattern')) {
                          <mat-error>
                            Wrong link format
                          </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field
                        [class.cursor-pointer]="!!getFormValue('instagram.svg')"
                        (click)="redirectToSocialMedia(getFormValue('instagram.svg'))">
                        <mat-label>Instagram profile link</mat-label>
                        <input
                          matInput
        [placeholder]="
            getFormValue('instagram.svg') ||
            !mediaControls.get('instagram').disabled
              ? 'Instagram profile link'
              : ''
          "
                          formControlName="instagram"
                          />
                          <div class="icon icon-instagram" matPrefix></div>
                          @if (mediaControls.get('instagram').hasError('pattern')) {
                            <mat-error>
                              Wrong link format
                            </mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field
                          class="0"
                          [class.cursor-pointer]="!!getFormValue('twitter')"
                          (click)="redirectToSocialMedia(getFormValue('twitter'))"
                          >
                          <mat-label>Twitter profile link</mat-label>
                          <input
                            matInput
        [placeholder]="
            getFormValue('twitter') || !mediaControls.get('twitter').disabled
              ? 'Twitter profile link'
              : ''
          "
                            formControlName="twitter"
                            />
                            <div class="icon icon-twitter" matPrefix></div>
                            @if (mediaControls.get('twitter').hasError('pattern')) {
                              <mat-error>
                                Wrong link format
                              </mat-error>
                            }
                          </mat-form-field>
                          <mat-form-field
                            class="0"
                            [class.cursor-pointer]="!!getFormValue('youtube')"
                            (click)="redirectToSocialMedia(getFormValue('youtube'))"
                            >
                            <mat-label>Youtube profile link</mat-label>
                            <input
                              matInput
        [placeholder]="
            getFormValue('youtube') || !mediaControls.get('youtube').disabled
              ? 'Youtube profile link'
              : ''
          "
                              formControlName="youtube"
                              />
                              <div class="icon icon-youtube" matPrefix></div>
                              @if (mediaControls.get('youtube').hasError('pattern')) {
                                <mat-error>
                                  Wrong link format
                                </mat-error>
                              }
                            </mat-form-field>
                          </ng-container>
                          <!--  <div class="mb-4" *ngIf="showChangePassword">-->
                          <!--    <span class="active-link" (click)="openChangePassword()">-->
                          <!--      Change Password-->
                        <!--    </span>-->
                        <!--    &lt;!&ndash;    <div class="active-link" (click)="openDeactivate()"> Deactivate Account</div>&ndash;&gt;-->
                      <!--  </div>-->
                    </form>
